// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"ModalWindow_modal_wrapper__2N7k5","modal_title":"ModalWindow_modal_title__a0lPh","modal_text":"ModalWindow_modal_text__8VFiv"};